// proto/v2/export/export.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file export/export.proto (package lvdr.v2.export, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file export/export.proto.
 */
export const file_export_export: GenFile = /*@__PURE__*/
  fileDesc("ChNleHBvcnQvZXhwb3J0LnByb3RvEg5sdmRyLnYyLmV4cG9ydCJTChVFeHBvcnRSZXNlYXJjaFJlcXVlc3QSEwoLcmVzZWFyY2hfaWQYASABKAkSDgoGZm9ybWF0GAIgASgJEhUKDXN0eWxlX3Byb2ZpbGUYAyABKAkitwEKFkV4cG9ydFJlc2VhcmNoUmVzcG9uc2USEwoLcmVzZWFyY2hfaWQYASABKAkSEQoJZXhwb3J0X2lkGAIgASgJEg4KBnN0YXR1cxgDIAEoCRIPCgdjb250ZW50GAQgASgJEhAKCGZpbGVuYW1lGAUgASgJEhQKDHZlcnNpb25faGFzaBgGIAEoCRIsCgZmb3JtYXQYByABKA4yHC5sdmRyLnYyLmV4cG9ydC5FeHBvcnRGb3JtYXQingEKEUV4cG9ydFN0YXR1c0V2ZW50EhMKC3Jlc2VhcmNoX2lkGAEgASgJEhEKCWV4cG9ydF9pZBgCIAEoCRIOCgZzdGF0dXMYAyABKAkSEAoIcHJvZ3Jlc3MYBCABKAESDQoFZXJyb3IYBSABKAkSMAoMY29tcGxldGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCpZCgxFeHBvcnRGb3JtYXQSGgoWRVhQT1JUX0ZPUk1BVF9NQVJLRE9XThAAEhYKEkVYUE9SVF9GT1JNQVRfSFRNTBABEhUKEUVYUE9SVF9GT1JNQVRfUERGEAJCJ1olZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2V4cG9ydGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.export.ExportResearchRequest
 */
export type ExportResearchRequest = Message<"lvdr.v2.export.ExportResearchRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string format = 2;
   */
  format: string;

  /**
   * Optional style-profile id (NOTES-07) applied to html/pdf output;
   * empty/unknown falls back to the default report look.
   *
   * @generated from field: string style_profile = 3;
   */
  styleProfile: string;
};

/**
 * Describes the message lvdr.v2.export.ExportResearchRequest.
 * Use `create(ExportResearchRequestSchema)` to create a new message.
 */
export const ExportResearchRequestSchema: GenMessage<ExportResearchRequest> = /*@__PURE__*/
  messageDesc(file_export_export, 0);

/**
 * Responses
 *
 * @generated from message lvdr.v2.export.ExportResearchResponse
 */
export type ExportResearchResponse = Message<"lvdr.v2.export.ExportResearchResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string export_id = 2;
   */
  exportId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: string filename = 5;
   */
  filename: string;

  /**
   * @generated from field: string version_hash = 6;
   */
  versionHash: string;

  /**
   * @generated from field: lvdr.v2.export.ExportFormat format = 7;
   */
  format: ExportFormat;
};

/**
 * Describes the message lvdr.v2.export.ExportResearchResponse.
 * Use `create(ExportResearchResponseSchema)` to create a new message.
 */
export const ExportResearchResponseSchema: GenMessage<ExportResearchResponse> = /*@__PURE__*/
  messageDesc(file_export_export, 1);

/**
 * Events
 *
 * @generated from message lvdr.v2.export.ExportStatusEvent
 */
export type ExportStatusEvent = Message<"lvdr.v2.export.ExportStatusEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string export_id = 2;
   */
  exportId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: double progress = 4;
   */
  progress: number;

  /**
   * @generated from field: string error = 5;
   */
  error: string;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 6;
   */
  completedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.export.ExportStatusEvent.
 * Use `create(ExportStatusEventSchema)` to create a new message.
 */
export const ExportStatusEventSchema: GenMessage<ExportStatusEvent> = /*@__PURE__*/
  messageDesc(file_export_export, 2);

/**
 * Enums
 *
 * @generated from enum lvdr.v2.export.ExportFormat
 */
export enum ExportFormat {
  /**
   * @generated from enum value: EXPORT_FORMAT_MARKDOWN = 0;
   */
  MARKDOWN = 0,

  /**
   * @generated from enum value: EXPORT_FORMAT_HTML = 1;
   */
  HTML = 1,

  /**
   * @generated from enum value: EXPORT_FORMAT_PDF = 2;
   */
  PDF = 2,
}

/**
 * Describes the enum lvdr.v2.export.ExportFormat.
 */
export const ExportFormatSchema: GenEnum<ExportFormat> = /*@__PURE__*/
  enumDesc(file_export_export, 0);

